import { useState, useEffect } from "react";
import { fetchLeadDetails } from "../services/leads.service";
import { mapLeadDetails } from "../utils/firebaseLeadsMapper";

export function useLeadDetails(waId) {
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!waId) {
      setDetails(null);
      return;
    }

    setLoading(true);
    fetchLeadDetails(waId)
      .then((raw) => {
        setDetails(mapLeadDetails(raw));
      })
      .catch(() => {
        setDetails(null);
      })
      .finally(() => setLoading(false));
  }, [waId]);

  return { details, loading };
}
